import { DropdownItem } from '@shared/abstraction';
import { TaxResultItemType } from '@shared/enums/tax-result-item-type';

export const taxResultTypeItems: DropdownItem[] = [
  {
    value: TaxResultItemType.CapitalGains,
    label: 'Capital gains',
  },
  {
    value: TaxResultItemType.Dividends,
    label: 'Withholding tax',
  },
];
